import request from '@/utils/request'
// 公告政策列表
export function nocget(params) {
    return request({
        url: 'system/notice/listNotice',
        method: 'get',
        params
    })
}